import {combineTranslationBundles} from '@hconnect/common/localization-loaders'
import {kmsWidgetTranslations} from '@widgets/kms'
import {rcfaOverviewWidgetTranslations} from '@widgets/rcfa-overview'

export const maintainDashboardFeatureTranslations = combineTranslationBundles([
  rcfaOverviewWidgetTranslations,
  kmsWidgetTranslations
])
